import { FENCE_TYPES } from '../constants/fences';

export const getFenceTypeLabel = (fenceType: number) => {
  return FENCE_TYPES.find((fence) => fence.type === fenceType)?.name;
};
